module.exports = __webpack_public_path__ + "images/mobile/img-dingtalk-arrow-25306d06f406c2e6f1078de84711cc0c.png";